<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      :width="tool == 'editor' ? '90vw' : '400px'"
      :retain-focus="false"
      transition="dialog-top-transition"
    >
      <v-card flat>
        <v-card-title />
        <v-card-text>
          <my-bloc-note v-if="tool === 'editor'" />
          <my-calculate v-if="tool === 'calc'" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" dark @click="saveBlocNote()">Sortir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-speed-dial
      v-if="user.is_active"
      v-model="fab"
      absolute
      fixed
      top
      direction="bottom"
      transition="scale-transition"
      right
      open-on-hover
      style="z-index: 15"
    >
      <template v-slot:activator>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              v-model="fab"
              color="orange"
              dark
              fab
              v-bind="attrs"
              v-on="on"
            >
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-toolbox-outline</v-icon>
            </v-btn>
          </template>
          <span>Outils</span>
        </v-tooltip>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="pink"
            dark
            fab
            x-small
            @click="(dialog = !dialog) && (tool = 'editor')"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-book-edit-outline</v-icon>
          </v-btn>
        </template>
        <span>Bloc-notes</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="pink"
            dark
            fab
            x-small
            @click="(dialog = !dialog) && (tool = 'calc')"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-calculator-variant-outline</v-icon>
          </v-btn>
        </template>
        <span>Calculatrice</span>
      </v-tooltip>
    </v-speed-dial>
  </div>
</template>

<script>
import MyBlocNote from "./MyBlocNote";
import MyCalculate from "./MyCalculate";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "MyDialogOutils",
  data() {
    return {
      dialog: false,
      fab: null,
      tool: null,
    };
  },
  components: {
    MyBlocNote,
    MyCalculate,
  },
  computed: {
    ...mapGetters({
      userBlocNoteError: "user/option/error",
      user: "user/current/retrieved",
    }),
  },
  methods: {
    ...mapActions({
      userBlocNote: "user/option/setBlocNote",
    }),
    saveBlocNote() {
      this.dialog = false;
      if (this.tool === "editor")
        this.userBlocNote({ blocnote: this.user.option.blocnote });
    },
  },
};
</script>
